/**
 * @generated SignedSource<<551ec2e3484c76d3ed8635880fce1089>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type portals_club$data = {
  readonly nextEvents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"portals_eventPortal">;
      };
    }>;
  };
  readonly " $fragmentType": "portals_club";
};
export type portals_club$key = {
  readonly " $data"?: portals_club$data;
  readonly " $fragmentSpreads": FragmentRefs<"portals_club">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "portals_club",
  "selections": [
    {
      "alias": "nextEvents",
      "args": [
        {
          "kind": "Literal",
          "name": "filterBy",
          "value": "UPCOMING"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "CHRONOLOGICAL"
        }
      ],
      "concreteType": "EventConnection",
      "kind": "LinkedField",
      "name": "events",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Event",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "portals_eventPortal"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "events(filterBy:\"UPCOMING\",first:1,orderBy:\"CHRONOLOGICAL\")"
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "51d517a3b4b2b44030231a30e3a0d2f1";

export default node;
